// removed by extract-text-webpack-plugin
module.exports = {"EstimateLink":"EstimateLink","Cta":"Cta","Cta__container--Light":"Cta__container--Light","Cta__button":"Cta__button","Cta__button__text":"Cta__button__text","Cta__container--Dark":"Cta__container--Dark"};


//////////////////
// WEBPACK FOOTER
// ./src/components/estimate-link/styles.css
// module id = 848
// module chunks = 0 1